export const USER_SERVICE_ENDPOINT = {
  TENANT_MAP: '/userDetail/tenantMap',
  PICKUP_ADDRESS: '/user/pickupLocation',
  USER_QUERY: '/user/query',
  GET_PICKUP_ADDRESS: '/user/pickupLocation',
  GET_USERS: '/users',
  GET_COMPANY_REGISTRATION_DETAILS: '/user/companyRegistrationDetails',
  GET_CSM_TENANTS: '/user/csm/tenant',
  SEARCH: '/search'
};
